import React from "react";
import clsx from "clsx";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import NavPills from "./Component/NavPills";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    paddingLeft: 0,
    paddingRight: 0,
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "hidden",
    backgroundColor: "#F6F6F6",
  },

  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(10),
    paddingRight: theme.spacing(17),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      marginLeft: "0px",
      paddingTop: "64px",
      paddingRight: "25px",
      paddingBottom: "0",
    },
  },
  link: {
    marginTop: theme.spacing(-6),
    marginBottom: theme.spacing(1),
    marginLeft: '-10px',
  },
}));

export default function Nftbuyer() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="" className={classes.container}>
          <Typography
            className={classes.link}
            variant="h6"
            color="#001441"
            id="top-text"
          >
            <IconButton onClick={() => history.push("/home/dashboard")}>
              <img src="/images/Backarrow.svg" />
            </IconButton>
            NFT Buyers
          </Typography>
          <Grid item xs={12} sm={12} md={12}>
            <NavPills />
          </Grid>
        </Container>
      </main>
    </div>
  );
}
